import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";
import { HttpService } from "./http.service";
import { ConfigurationService } from "./configuration.service";
import { Observable } from "rxjs";
import { NationalTeamGroupRating, PlayerDto, TeamCardsDto } from "../models";

@Injectable()
export class NationalTeamService extends BaseService {
    
    constructor(httpService: HttpService,
        configurationService: ConfigurationService) {
            super(httpService, configurationService);
    }

    getGroupRatings(): Observable<NationalTeamGroupRating[]> {
        return this.httpService.get<NationalTeamGroupRating[]>(this.apiUrl + 'national-teams/group-ratings', null);
    }

    getSquad(): Observable<PlayerDto[]> {
        return this.httpService.get<PlayerDto[]>(this.apiUrl + 'national-teams/squad', null);
    }

    getSquadById(id: number): Observable<PlayerDto[]> {
        return this.httpService.get<PlayerDto[]>(this.apiUrl + 'national-teams/squad/' + id, null);
    }

     getCards(teamId: number): Observable<TeamCardsDto> {
            return this.httpService.get<TeamCardsDto>(this.apiUrl + 'national-teams/' + teamId + '/cards', null);
    }
}